class puTianShiTuShuGuanMapToolTip {
  constructor(opt) {
    this.timer = opt.timer
    this.intervalHandle = null
    this.vm = opt.vm
    this.index = 1
    this.mapJson = null
    this.tooltipData = null
  }
  mouseoverPuTianCity = data => {
    clearInterval(this.intervalHandle)
    const dataIndex = this.tooltipData.findIndex(item => item.city === data.name)
    this.removeOldToolTop()
    this.index = dataIndex
    this.createDom(this.tooltipData[this.index]) //绘制dom
    this.startLoop(this.timer)
  }
  dispatchLoopSelectAction(opt) {
    this.initDom(opt)
    this.startLoop(this.timer)
  }
  startLoop(timer) {
    this.intervalHandle = setInterval(() => {
      this.removeOldToolTop()
      this.index = this.index + 1 >= this.tooltipData.length ? 0 : this.index + 1
      this.createDom(this.tooltipData[this.index]) //绘制dom
    }, timer)
  }
  initDom(opt) {
    this.removeOldToolTop() //移出之前的dom
    this.initMapJson() //初始化当前地图的json文件
    this.createDom(this.tooltipData[this.index++]) //绘制dom
  }
  initMapJson() {
    const name = this.vm.options.chartOption.name
    const mapName = name === "全国" ? "china" : name.split("/").reverse()[0]
    const mapJson = this.vm.$echarts.getMap(mapName)
    this.mapJson = mapJson
  }
  removeOldToolTop() {
    const el = this.vm.$el
    const oldNode = el.getElementsByClassName("puTianShiTuShuGuanMapToolTip")[0]
    if (oldNode) el.removeChild(oldNode)
  }
  createDom(mapData) {
    if (!mapData) return
    this.vm.$refs?.map?.dispatchAction &&
      this.vm.$refs.map.dispatchAction({
        type: "geoSelect",
        name: mapData.city
      })
    const wrapper = this.createWrapper()
    const head = this.createHead(mapData.city)
    const splitLine = this.createSplitLine()
    const content = this.createContent(mapData.value)
    const [lb, rt] = this.createBox()
    wrapper.appendChild(head)
    wrapper.appendChild(splitLine)
    wrapper.appendChild(content)
    wrapper.appendChild(lb)
    wrapper.appendChild(rt)
    this.vm.$el.appendChild(wrapper)
  }
  createBox() {
    const box1 = document.createElement("div")
    const box2 = document.createElement("div")
    const box1Style = { borderTop: "1px solid #4299FF", borderRight: "1px solid #4299FF", top: "0px", right: "0px" }
    const box2Style = { borderLeft: "1px solid #4299FF", borderBottom: "1px solid #4299FF", left: "0px", bottom: "0px" }
    const style = {
      width: "12px",
      height: "12px",
      background: "transparent",
      position: "absolute"
    }
    this.createStyle(box1, Object.assign(box1Style, style))
    this.createStyle(box2, Object.assign(box2Style, style))
    return [box1, box2]
  }
  createContent(data) {
    const content = document.createElement("div")
    this.createStyle(content, {
      width: "115px",
      height: "72px",
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px"
    })
    data.forEach(data => {
      const item = document.createElement("div")
      const name = document.createElement("span")
      const value = document.createElement("span")
      name.innerText = data.name + ":"
      this.createStyle(name, { marginRight: "5px" })
      this.createStyle(item, { marginBottom: "6px" })
      value.innerText = data.value + data.suffix
      item.appendChild(name)
      item.appendChild(value)
      content.appendChild(item)
    })
    return content
  }
  createSplitLine() {
    const line = document.createElement("div")
    this.createStyle(line, {
      height: "0px",
      width: "85px",
      borderBottom: "1px solid #4299FF",
      marginTop: "4px",
      marginBottom: "10px"
    })
    return line
  }
  createHead(name) {
    const head = document.createElement("div")
    head.innerText = name + "分馆"
    this.createStyle(head, {
      fontWeight: "600",
      fontSize: "17px",
      height: "24px",
      lineHeight: "24px",
      textAlign: "center",
      color: "#4299FF"
    })
    return head
  }
  createWrapper() {
    const wrapper = document.createElement("div")
    wrapper.className = "puTianShiTuShuGuanMapToolTip"
    this.createStyle(wrapper, {
      width: "155px",
      height: "135px",
      padding: "12px 24px",
      position: "absolute",
      right: "48px",
      top: "79px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      background:
        "linear-gradient(180deg, rgba(66, 153, 255, 0.135) 0%, rgba(66, 153, 255, 0.0225) 50.91%, rgba(66, 153, 255, 0.135) 100%)",
      boxShadow: "inset 0px 0px 4px rgba(66, 153, 255, 0.45)",
      backdropFilter: "blur(32px)"
    })
    return wrapper
  }
  createStyle(dom, style) {
    Object.keys(style).forEach(styleName => {
      dom.style[styleName] = style[styleName]
    })
  }
  updateData(k, v) {
    if (this.hasOwnProperty(k)) {
      this[k] = v
    } else {
      console.error("没有这个数据名：" + k)
    }
  }
}

export default {
  data() {
    return {
      puTianShiTuShuGuanMapToolTip: new puTianShiTuShuGuanMapToolTip({
        timer: 3000,
        vm: this
      })
    }
  },
  methods: {
    async puTianShiTuShuGuanMapToolTipPlugin(opt, self) {
      clearInterval(this.puTianShiTuShuGuanMapToolTip.intervalHandle)
      const tooltipData = await Promise.resolve([
        {
          city: "荔城区",
          value: [
            { name: "今日到馆", value: "219", suffix: "人" },
            { name: "今日借还", value: "1321", suffix: "册" },
            { name: "今日办证", value: "89", suffix: "人" }
          ]
        },
        {
          city: "城厢区",
          value: [
            { name: "今日到馆", value: "11", suffix: "人" },
            { name: "今日借还", value: "342", suffix: "册" },
            { name: "今日办证", value: "32", suffix: "人" }
          ]
        },
        {
          city: "仙游县",
          value: [
            { name: "今日到馆", value: "123", suffix: "人" },
            { name: "今日借还", value: "343", suffix: "册" },
            { name: "今日办证", value: "22", suffix: "人" }
          ]
        },
        {
          city: "涵江区",
          value: [
            { name: "今日到馆", value: "3432", suffix: "人" },
            { name: "今日借还", value: "11", suffix: "册" },
            { name: "今日办证", value: "675", suffix: "人" }
          ]
        },
        {
          city: "秀屿区",
          value: [
            { name: "今日到馆", value: "456", suffix: "人" },
            { name: "今日借还", value: "3454", suffix: "册" },
            { name: "今日办证", value: "22", suffix: "人" }
          ]
        }
      ])
      this.puTianShiTuShuGuanMapToolTip.updateData("tooltipData", tooltipData)
      this.puTianShiTuShuGuanMapToolTip.dispatchLoopSelectAction(opt) //初始化提示框
      opt.geo.itemStyle.shadowColor = "rgb(101,212,241)"
      opt.geo.itemStyle.shadowBlur = 10
      opt.geo.itemStyle.shadowOffsetX = 5
      opt.geo.itemStyle.shadowOffsetY = 5
      // opt.geo.select.itemStyle.opacity = 0.2
    }
  },
  beforeDestroy() {
    clearInterval(this.puTianShiTuShuGuanMapToolTip.intervalHandle)
  },
  beforeUpdate() {
    clearInterval(this.puTianShiTuShuGuanMapToolTip.intervalHandle)
  }
}
